import React from 'react';
import SEO from '../components/SEO';

function Privacy() {
  // SEO structured data
  const seoStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': 'Privacy Policy',
    'description': 'Pharmaceutical Database privacy policy and data protection information'
  };

  return (
    <div className="page-container">
      <SEO
        title="Privacy Policy - Pharmaceutical Database"
        description="Read our privacy policy to learn how Pharmaceutical Database collects, uses, and protects your personal data. Updated October 23, 2025."
        keywords="privacy policy, data protection, GDPR, personal data, cookies, user privacy"
        canonical="/privacy"
        structuredData={seoStructuredData}
      />
      <h1 className="page-title">Privacy Policy</h1>
      <p className="page-description">Last updated: October 23, 2025</p>

      <div style={{ maxWidth: '900px', margin: '0 auto', color: '#7f8c8d', lineHeight: '1.8' }}>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Introduction</h2>
          <p>
            Pharmaceutical Database ("we", "our", or "us") operates the pharmaceutical database website. 
            This page informs you of our policies regarding the collection, use, and disclosure of personal data 
            when you use our service and the choices you have associated with that data.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Information Collection and Use</h2>
          <p>We collect several different types of information for various purposes to provide and improve our service.</p>
          
          <h3 style={{ color: '#34495e', marginTop: '1.5rem', marginBottom: '0.5rem' }}>Types of Data Collected:</h3>
          <ul style={{ marginLeft: '1.5rem' }}>
            <li><strong>Personal Data:</strong> Email address, name (when voluntarily provided)</li>
            <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, time and date of visits</li>
            <li><strong>Cookies:</strong> We use cookies for authentication and site analytics</li>
            <li><strong>Search History:</strong> Stored locally on your device for convenience</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Use of Data</h2>
          <p>Pharmaceutical Database uses the collected data for various purposes:</p>
          <ul style={{ marginLeft: '1.5rem' }}>
            <li>To provide and maintain our service</li>
            <li>To notify you about changes to our service</li>
            <li>To allow you to participate in interactive features</li>
            <li>To provide customer support and respond to inquiries</li>
            <li>To gather analysis or valuable information for service improvement</li>
            <li>To monitor the usage of our service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Security of Data</h2>
          <p>
            The security of your data is important to us, but remember that no method of transmission over 
            the Internet or method of electronic storage is 100% secure. While we strive to use commercially 
            acceptable means to protect your personal data, we cannot guarantee its absolute security.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting 
            the new Privacy Policy on this page and updating the "Last updated" date at the top of this page.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:<br/>
            Email: <a href="mailto:admin@ijcbr.com" style={{ color: '#3498db', textDecoration: 'none' }}>admin@ijcbr.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
